import React from 'react';
import { ClipboardList, Hammer, Wrench, Sparkles } from 'lucide-react';

const NewWorkProcess = () => {
  const steps = [
    {
      icon: ClipboardList,
      number: '1',
      title: 'Consultation',
      description: 'We discuss your needs, assess the site, and provide expert recommendations.',
    },
    {
      icon: Wrench,
      title: 'Surface Preparation',
      number: '2',
      description: 'Thorough cleaning and preparation ensures optimal tile adhesion.',
    },
    {
      icon: Hammer,
      number: '3',
      title: 'Tiling Installation',
      description: 'Professional installation using proven techniques and quality materials.',
    },
    {
      icon: Sparkles,
      number: '4',
      title: 'Finishing and Clean-up',
      description: 'Final touches, grouting, and complete site cleanup for perfection.',
    },
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our Work Process
          </h2>
          <div className="w-24 h-1 bg-blue-600 mx-auto mb-4"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            A proven approach that delivers quality results every time
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => {
            const IconComponent = step.icon;
            return (
              <div key={index} className="relative">
                <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300">
                  {/* Number Badge */}
                  <div className="absolute -top-4 -right-4 bg-blue-600 text-white w-12 h-12 rounded-full flex items-center justify-center font-bold text-xl shadow-lg">
                    {step.number}
                  </div>
                  
                  {/* Icon */}
                  <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-100 rounded-full mb-6">
                    <IconComponent className="w-8 h-8 text-blue-600" />
                  </div>
                  
                  {/* Content */}
                  <h3 className="text-xl font-bold text-gray-900 mb-3">{step.title}</h3>
                  <p className="text-gray-600 leading-relaxed">{step.description}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default NewWorkProcess;